export default __webpack_public_path__ + "static/media/Startup_SVG.d6335a12.svg";